<template>
  <div class="addSetContainer">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="上级项目">
        <a-select
          showSearch
          :filterOption="filterOption"
          v-model="selectedOneVal"
          @change="selectedOne"
          placeholder="请选择项目"
          style="width: 160px; margin-right: 10px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListOne"
            :key="i + 't'"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <a-select
          @change="selectedTwo"
          v-model="selectedTwoVal"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择项目"
          style="width: 160px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListTwo"
            :key="i + 'j'"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="关联项目" prop="project_ids">
        <a-select
          :maxTagCount="10"
          mode="multiple"
          style="width: 86%; margin-right: 10px"
          v-model="form.project_ids"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择关联项目"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListThree"
            :key="i + 'c'"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox :checked="checked" @change="selectedAll">全选</a-checkbox>
        </span>
      </a-form-model-item>
      <a-form-model-item label="渠道类型" prop="resume_source">
        <a-checkbox-group v-model="form.resume_source">
          <a-checkbox :disabled="isSelectType" :value="3" name="resume_source"
            >玄鸟员工</a-checkbox
          >
          <!-- <a-checkbox :value="2" name="resume_source">转介绍</a-checkbox> -->
          <a-checkbox :value="4" name="resume_source">三方渠道</a-checkbox>
          <a-checkbox :disabled="isSelectType" :value="2" name="resume_source"
            >芜湖招聘部</a-checkbox
          >
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item
        label="岗位"
        prop="job"
        v-if="form.resume_source.includes(3)"
      >
        <a-select v-model="form.job">
          <a-select-option
            v-for="(element, k) in roleList"
            :key="k"
            :value="element.id"
            >{{ element.role_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.resume_source.includes(3)"
        label="底薪类型"
        ref="salary_type"
        prop="salary_type"
      >
        <a-radio-group v-model="form.salary_type">
          <a-radio :value="1">无责底薪</a-radio>
          <a-radio :value="2">有责底薪</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.resume_source.includes(3) && form.salary_type == 2"
        label="满足条件"
        ref="salary_type_person"
        prop="salary_type_person"
      >
        <a-input-number v-model="form.salary_type_person" :min="0" />
        <span>&nbsp;人</span>
      </a-form-model-item>
      <a-form-model-item
        label="三方渠道"
        prop="resume_third_id"
        v-if="form.resume_source == '' ? false : form.resume_source.includes(4)"
      >
        <a-select
          v-model="form.resume_third_id"
          mode="multiple"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择三方渠道"
        >
          <a-select-option
            v-for="(item, j) in thirdList"
            :key="j + 'l'"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="结算方式" prop="statement_type">
        <a-radio-group v-model="form.statement_type" @change="selectType">
          <a-radio :value="1">出勤天数常规结算</a-radio>
          <a-radio :value="2">出勤天数阶梯结算</a-radio>
          <a-radio :value="3">时新结算</a-radio>
          <a-radio :value="4">订单/工单结算</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <!-- 模版一 -->
      <!-- <a-form-model-item
        label="最低出勤天数"
        v-show="form.type == 1 || form.type == 2"
      >
        <a-input-number />
        <span>&nbsp;天</span>
      </a-form-model-item> -->
      <a-form-model-item
        label="出勤需满天数"
        prop="day"
        v-if="form.statement_type == 1 || form.statement_type == 2"
      >
        <a-input-number :min="0" v-model="form.day" />
        <span>&nbsp;天</span>
      </a-form-model-item>
      <!-- 模版 end一 -->
      <!-- 模版四 -->
      <a-form-model-item
        prop="hour"
        label="需满小时数"
        v-if="form.statement_type == 3"
      >
        <a-input-number v-model="form.hour" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 模版四 end -->
      <!-- 模版五 -->
      <a-form-model-item label="需满单量" v-show="form.statement_type == 4">
        <a-input-number v-model="form.order" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 模版五 end -->
      <a-form-model-item label="结算周期" prop="statement_cycle">
        <a-radio-group v-model="form.statement_cycle">
          <a-radio
            :value="item.id"
            v-for="(item, k) in dateTypeText"
            :key="k + 'k'"
            >{{ item.name }}</a-radio
          >
        </a-radio-group>
      </a-form-model-item>

      <!-- 一次性结算 长返 -->

      <a-form-model-item
        label="服务费"
        prop="service"
        v-if="form.statement_type == 1"
      >
        <a-input-number :min="0" v-model="form.service" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item
        label="每小时"
        prop="every_hour"
        v-if="form.statement_type == 3"
      >
        <a-input-number v-model="form.every_hour" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item
        label="每单"
        prop="every_order"
        v-if="form.statement_type == 4"
      >
        <a-input-number v-model="form.every_order" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 一次性结算  长返 end -->
      <!-- 模版二 -->
      <a-form-model-item
        style="vertical-align: middle"
        v-if="form.statement_type == 2"
        label="阶梯"
      >
        <div v-for="(element, i) in step" :key="i + '1'">
          <span>累计人数&nbsp;&nbsp;</span>
          <a-input-number v-model="element.min" :min="0" />
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>累计人数&nbsp;&nbsp;</span>
          <a-input-number v-model="element.max" :min="element.min + 1" />
          <a-icon
            @click="addLadder(i, element.txt)"
            style="
              font-size: 32px;
              color: #999;
              vertical-align: middle;
              margin-left: 10px;
            "
            :type="element.txt == '增加' ? 'plus-square' : 'minus-square'"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item
        v-show="
          element.max != '' && form.statement_type == 2 && element.max != null
        "
        v-for="(element, j) in step"
        :key="j + 'element'"
        style="vertical-align: middle"
        label="服务费"
      >
        <span>{{
          element.min + "&nbsp;~&nbsp;" + element.max + "&nbsp;人&nbsp;&nbsp;"
        }}</span>
        <a-input-number
          v-model="element.service"
          :min="0"
          style="margin-right: 10px"
        />
        <span>元</span>
      </a-form-model-item>
      <!-- 模版二 end -->
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button @click="resetForm('ruleForm')"> 重置 </a-button>
        <a-button style="margin-left: 20px" type="primary" @click="onSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        statement_type: 1,
        statement_cycle: "",
        monthCost: "",
        resume_source: [],
        project_ids: [],
        job: "",
        resume_third_id: [],
        day: "",
        hour: "",
        order: "",
        service: "",
        every_order: "",
        every_hour: "",
        salary_type: 1,
        salary_type_person: ""
      },
      rules: {
        every_hour: [
          {
            required: true,
            message: "请输入时薪",
            trigger: "blur"
          }
        ],
        every_order: [
          {
            required: true,
            message: "请输入单价",
            trigger: "blur"
          }
        ],
        service: [
          {
            required: true,
            message: "请输入服务费",
            trigger: "blur"
          }
        ],
        order: [
          {
            required: true,
            message: "请输入需满单量",
            trigger: "blur"
          }
        ],
        hour: [
          {
            required: true,
            message: "请输入需满小时数",
            trigger: "blur"
          }
        ],
        day: [
          {
            required: true,
            message: "请输入出勤需满天数",
            trigger: "blur"
          }
        ],
        resume_third_id: [
          {
            required: true,
            message: "请选择三方",
            trigger: "change"
          }
        ],
        job: [
          {
            required: true,
            message: "请选择岗位",
            trigger: "change"
          }
        ],
        statement_type: [
          {
            required: true,
            message: "请选择结算方式",
            trigger: "change"
          }
        ],
        salary_type_person: [
          {
            required: true,
            message: "请填写满足条件",
            trigger: "blur"
          }
        ],
        project_ids: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        resume_source: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        statement_cycle: [
          {
            required: true,
            message: "请选择结算周期",
            trigger: "change"
          }
        ]
      },
      step: [{ min: 0, max: "", txt: "增加", service: "" }],
      costList: [],
      disabled: false,
      dateTypeText: [
        {
          name: "一次性结算",
          id: 1
        },
        {
          name: "长返",
          id: 2
        }
      ],
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      checked: false,
      thirdList: [],
      roleList: [],
      isSelectType: false
    };
  },
  computed: {
    monthCostComputed() {
      return this.form.monthCost;
    }
  },
  mounted() {
    this.getProOne(); //获取一级项目列表
    this.getPro();
    this.getThirdParty(); //三方公司
    this.getRole();
  },
  watch: {
    monthCostComputed() {
      if (Number(this.form.monthCost) > 0) {
        this.costList.length = Number(this.form.monthCost);
      }
    }
  },
  methods: {
    getRole() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 1000,
          role_type: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.roleList = res.data.data.data;
            // console.log(this.roleList);
          }
        });
    },
    selectType() {
      if (this.form.statement_type == 2) {
        this.isSelectType = true;
        this.form.resume_source = [4]; //阶梯计算方式只有三方公司
        this.form.job = "";
        this.$forceUpdate();
      } else {
        this.isSelectType = false;
      }
    },
    getThirdParty() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.thirdList = res.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    selectedAll(e) {
      this.checked = e.target.checked;
      if (this.selectedOneVal == "") {
        this.project_ids = [];
      }
      if (e.target.checked) {
        this.proListThree.forEach(element => {
          if (this.project_ids.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.project_ids.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.project_ids = [];
      }
    },
    selectedOne(id) {
      this.checked = false;
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.getProID(id, 1); //获取下级项目
      this.getThreePro(id);
      // console.log(id);
    },
    selectedTwo(id) {
      this.checked = false;
      this.isShowThree = true;
      this.getProID(id, 2); //获取下级项目
    },
    getThreePro(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectTop";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            // console.log(this.proListThree);
          }
        });
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            // console.log(this.proListThree);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.people +
            "Recruitment_cost/add";
          let step = [];
          this.step.forEach(item => {
            step.push({
              min: item.min,
              max: item.max,
              service: item.service
            });
          });
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            project_ids: JSON.stringify(this.form.project_ids),
            resume_source: JSON.stringify(this.form.resume_source),
            resume_third_id: JSON.stringify(this.form.resume_third_id),
            statement_type: this.form.statement_type,
            day: this.form.day,
            hour: this.form.hour,
            order: this.form.order,
            statement_cycle: this.form.statement_cycle,
            service: this.form.service,
            every_hour: this.form.every_hour,
            every_order: this.form.every_order,
            step: JSON.stringify(step),
            job: this.form.job,
            salary_type: this.form.salary_type,
            salary_type_person: this.form.salary_type_person
          };
          if (this.form.statement_type != 2) {
            delete params.step;
          }
          if (!this.form.resume_source.includes(3)) {
            delete params.job;
            delete params.salary_type;
            delete params.salary_type_person;
          }
          console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$emit("hideInAdd", false);
              this.resetForm("ruleForm");
              this.$message.success("提交成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.isSelectType = false;
      this.$refs[formName].resetFields();
    },
    addLadder(index, txt) {
      if (txt == "增加") {
        if (this.step[this.step.length - 1].max != "") {
          this.step.push({
            min: this.step[this.step.length - 1].max,
            max: "",
            txt: "减少",
            service: ""
          });
        } else {
          this.$message.error("请先填写最大值！");
        }
      } else {
        this.step.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="less">
.addSetContainer {
  margin: 30px 2% 50px;
  padding-bottom: 30px;
  .ant-form-item {
    margin-bottom: 14px;
  }
  .ant-form-item label {
    margin-bottom: 10px;
  }
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
}
</style>
